export default __webpack_public_path__ + "static/media/ic-done.66e7814e.svg";